import { Reducer } from 'redux';
import { Dependent } from 'types';

import { Actions } from 'store/actions/dependents.action';
import {
  DEPENDENTS_ADD,
  DEPENDENTS_LOADING,
  DEPENDENTS_LOADED,
  DEPENDENTS_ADD_ONE,
  DEPENDENT_UPDATE,
  DEPENDENT_DETAILED,
  DEPENDENT_RESET,
  DEPENDENTS_FAILURE,
  DEPENDENT_REQUESTS_LOADING,
  DEPENDENT_REQUESTS_LOADED,
  DEPENDENT_REQUESTS_FAILURE,
  DEPENDENT_REQUESTS_RESET,
  RESET_ERROR,
} from 'store/types/dependents.type';

import { RootReducerType } from './index';

export type State = {
  data: Dependent[];
  isLoading: boolean;
  detailed?: Dependent;
  error: string;
  requestsData: any;
};

const initialState: State = {
  data: [],
  isLoading: false,
  detailed: undefined,
  error: '',
  requestsData: [],
};

export const dependentsReducer: Reducer<State, Actions> = (state = initialState, action) => {
  switch (action.type) {
    case DEPENDENTS_ADD:
      return { ...state, data: action.data, isLoading: false };
    case DEPENDENTS_FAILURE:
      return { ...state, error: action.error, isLoading: false };
    case DEPENDENTS_LOADING:
      return { ...state, isLoading: true };
    case DEPENDENTS_LOADED:
      return { ...state, isLoading: false };
    case DEPENDENTS_ADD_ONE:
      return { ...state, data: [...(state.data || []), action.item], isLoading: false };
    case DEPENDENT_DETAILED:
      return { ...state, detailed: action.item, isLoading: false };
    case DEPENDENT_UPDATE:
      if (state.data?.find(i => i.id === action.item.id))
        return { ...state, data: state.data?.map(i => (i.id === action.item.id ? action.item : i)), isLoading: false };
      else return { ...state, data: [...(state.data || []), action.item], isLoading: false };

    /** Dependent Requests */
    case DEPENDENT_REQUESTS_LOADING: {
      let index = state.requestsData.findIndex((item: any) => item.id == action.id);
      if (index !== -1)
        return {
          ...state,
          requestsData: [
            ...state.requestsData.slice(0, index),
            { ...state.requestsData[index], isLoading: true, requests: [], error: null },
            state.requestsData.slice(0, index + 1),
          ],
        };
      return { ...state, requestsData: state.requestsData.concat({ id: action.id, requests: [], isLoading: true }) };
    }
    case DEPENDENT_REQUESTS_LOADED: {
      let index = state.requestsData.findIndex((item: any) => item.id == action.id);
      return {
        ...state,
        requestsData: [
          ...state.requestsData.slice(0, index),
          {
            ...state.requestsData[index],
            isLoading: false,
            requests: action.requests,
            totalPages: action.totalPages,
          },
          state.requestsData.slice(0, index + 1),
        ],
      };
    }
    case DEPENDENT_REQUESTS_FAILURE: {
      let index = state.requestsData.findIndex((item: any) => item.id == action.id);
      return {
        ...state,
        requestsData: [
          ...state.requestsData.slice(0, index),
          {
            ...state.requestsData[index],
            isLoading: false,
            error: action.error,
          },
          state.requestsData.slice(0, index + 1),
        ],
      };
    }
    case DEPENDENT_REQUESTS_RESET:
      return { ...state, requestsData: [] };

    case DEPENDENT_RESET:
      return { ...state, detailed: undefined };
    case RESET_ERROR:
      return { ...state, error: '' };

    default:
      return state;
  }
};

export const dependentsSelector = (state: RootReducerType) => state.dependents;
export default dependentsReducer;
